<template>
  <div class="content voucher-template-detail fixContent">
    <div class="form-container">
      <a-card :title="$t('基本信息')" class="mb16">
        <a-form-model :model="voucherTemplate" :rules="rules" ref="formRef">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-model-item :label="$t('模板名称')" prop="template_name">
                <a-input
                  v-model="voucherTemplate.template_name"
                  :placeholder="$t('请输入模板名称')"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('模板编码')" prop="template_code">
                <a-input
                  v-model="voucherTemplate.template_code"
                  :placeholder="$t('请输入模板编码')"
                  :disabled="!!id"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('对应单据')" prop="doc">
                <a-select
                  v-model="voucherTemplate.doc"
                  show-search
                  option-filter-prop="children"
                  :placeholder="$t('请选择对应单据')"
                  :disabled="!!id"
                  @change="handleDocChange"
                >
                  <a-select-option v-for="item in documentList" :key="item.code" :value="item.code">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('凭证字')" prop="voucher_type">
                <a-select v-model="voucherTemplate.voucher_type" :placeholder="$t('请选择凭证字')">
                  <a-select-option
                    v-for="item in journal_voucher_type"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('科目表')" prop="account_table_code">
                <a-select
                  v-model="voucherTemplate.account_table_code"
                  @change="handleAccountTableChange"
                  :placeholder="$t('请选择科目表')"
                >
                  <a-select-option
                    v-for="item in accountTableList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('记账日期规则')" prop="accounting_date">
                <a-select
                  v-model="voucherTemplate.accounting_date"
                  allow-clear
                  show-search
                  option-filter-prop="children"
                  :placeholder="$t('请选择记账日期规则')"
                  :disabled="!voucherTemplate.doc"
                >
                  <a-select-option
                    v-for="field in mainFields"
                    :key="field.field_code"
                    :value="field.field_code"
                  >
                    {{ field.field_name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item :label="$t('业务日期规则')" prop="biz_date">
                <a-select
                  v-model="voucherTemplate.biz_date"
                  allow-clear
                  show-search
                  option-filter-prop="children"
                  :placeholder="$t('请选择业务日期规则')"
                  :disabled="!voucherTemplate.doc"
                >
                  <a-select-option
                    v-for="field in mainFields"
                    :key="field.field_code"
                    :value="field.field_code"
                  >
                    {{ field.field_name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>

      <template v-if="voucherTemplate.doc">
        <a-card :title="$t('生成条件')" class="mb16">
          <ConditionList
            :condition-list="voucherTemplate.condition_list"
            :fields="mainFields"
            :doc-code="voucherTemplate.doc"
            @add="addCondition(voucherTemplate.condition_list)"
            @remove="(index) => removeCondition(voucherTemplate.condition_list, index)"
          />
        </a-card>

        <a-card :title="$t('明细规则')">
          <div class="mb10">
            <a-button type="primary" size="small" @click="addDetail">
              <a-icon type="plus" />
              {{ $t('添加明细') }}
            </a-button>
          </div>
          <a-table
            :columns="detailColumns"
            :data-source="voucherTemplate.detail_list"
            :pagination="false"
            row-key="temp_id"
            size="small"
            bordered
          >
            <template slot="summary" slot-scope="text, record">
              <a-input v-model="record.summary" size="small" />
            </template>
            <template slot="balance_direction" slot-scope="text, record">
              <a-select v-model="record.balance_direction" size="small" style="width: 100%">
                <a-select-option
                  v-for="item in balance_direction"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </template>
            <template slot="account" slot-scope="text, record">
              <a-input
                readOnly
                :value="record.account_name ? `${record.account_name}(${record.account_code})` : ''"
                @click="openAccountModal(record)"
                :placeholder="$t('选择科目')"
                size="small"
              >
                <a-icon slot="suffix" type="search" />
              </a-input>
            </template>
            <template slot="amount" slot-scope="text, record">
              <div class="flex-ct gap5">
                <a-select v-model="record.amount_sign" size="small" style="width: 55px">
                  <a-select-option value="1">+</a-select-option>
                  <a-select-option value="-1">-</a-select-option>
                </a-select>
                <a-select
                  v-model="record.amount"
                  size="small"
                  style="flex: 1"
                  show-search
                  option-filter-prop="children"
                  :placeholder="$t('选择字段')"
                >
                  <a-select-option
                    v-for="field in allDetailFields"
                    :key="field.field_code"
                    :value="field.field_code"
                  >
                    {{ field.field_name }}
                  </a-select-option>
                </a-select>
              </div>
            </template>
            <template slot="currency" slot-scope="text, record">
              <a-select
                v-model="record.currency"
                size="small"
                style="width: 100%"
                show-search
                option-filter-prop="children"
              >
                <a-select-option
                  v-for="field in allDetailFields"
                  :key="field.field_code"
                  :value="field.field_code"
                >
                  {{ field.field_name }}
                </a-select-option>
              </a-select>
            </template>
            <template slot="condition" slot-scope="text, record">
              <a-popover title="条件设置" trigger="click" placement="left">
                <template slot="content">
                  <div style="width: 820px">
                    <ConditionList
                      :condition-list="record.condition_list"
                      :fields="allDetailFields"
                      :doc-code="voucherTemplate.doc"
                      @add="addCondition(record.condition_list)"
                      @remove="(index) => removeCondition(record.condition_list, index)"
                    />
                  </div>
                </template>
                <a-badge :count="record.condition_list.length" :overflow-count="99">
                  <a-button size="small">{{ $t('设置条件') }}</a-button>
                </a-badge>
              </a-popover>
            </template>
            <template slot="action" slot-scope="text, record, index">
              <a-button type="link" size="small" class="text-danger" @click="removeDetail(index)">
                {{ $t('删除') }}
              </a-button>
            </template>
          </a-table>
        </a-card>
      </template>
    </div>

    <selectAccountModal ref="selectAccountModalRef" :single="true" @ok="handleAccountSelected" />
    <div class="footer">
      <a-button @click="$router.back()">{{ $t('返回') }}</a-button>
      <a-button type="primary" :loading="saveLoading" @click="handleSave" style="margin-left: 12px">
        {{ $t('保存') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import ConditionList from './components/ConditionList.vue'
import selectAccountModal from '@/component/selectAccountModal.vue'

export default {
  name: 'VoucherTemplateDetail',
  components: { ConditionList, selectAccountModal },
  data() {
    return {
      id: this.$route.query.id,
      copyId: this.$route.query.copyId,
      saveLoading: false,
      voucherTemplate: {
        account_table_code: '',
        account_table_name: '',
        accounting_date: '',
        biz_date: '',
        business_unit: '',
        condition_list: [],
        detail_list: [],
        doc: '',
        template_code: '',
        template_name: '',
        voucher_type: '',
      },
      documentList: [],
      accountTableList: [],
      mainFields: [],
      allDetailFields: [],
      childDocs: [],
      currentEditDetail: null,
      rules: {
        template_name: [{ required: true, message: this.$t('请输入模板名称'), trigger: 'blur' }],
        template_code: [{ required: true, message: this.$t('请输入模板编码'), trigger: 'blur' }],
        doc: [{ required: true, message: this.$t('请选择对应单据'), trigger: 'change' }],
        voucher_type: [{ required: true, message: this.$t('请选择凭证字'), trigger: 'change' }],
        account_table_code: [
          { required: true, message: this.$t('请选择科目表'), trigger: 'change' },
        ],
      },
    }
  },
  activated() {
    this.init()
  },
  computed: {
    ...mapState(['journal_voucher_type', 'balance_direction']),
    detailColumns() {
      return [
        {
          title: this.$t('摘要'),
          dataIndex: 'summary',
          width: 150,
          scopedSlots: { customRender: 'summary' },
        },
        {
          title: this.$t('方向'),
          dataIndex: 'balance_direction',
          width: 100,
          scopedSlots: { customRender: 'balance_direction' },
        },
        {
          title: this.$t('科目'),
          dataIndex: 'account',
          width: 300,
          scopedSlots: { customRender: 'account' },
        },
        {
          title: this.$t('金额规则'),
          dataIndex: 'amount',
          width: 250,
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: this.$t('币种规则'),
          dataIndex: 'currency',
          width: 200,
          scopedSlots: { customRender: 'currency' },
        },
        {
          title: this.$t('生效条件'),
          dataIndex: 'condition',
          width: 100,
          scopedSlots: { customRender: 'condition' },
          align: 'center',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 80,
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ]
    },
  },
  mounted() {
    this.fetchDocumentList()
    this.fetchAccountTableList()
  },
  methods: {
    init() {
      this.id = this.$route.query.id
      this.copyId = this.$route.query.copyId
      this.voucherTemplate = {
        account_table_code: '',
        account_table_name: '',
        accounting_date: '',
        biz_date: '',
        business_unit: '',
        condition_list: [],
        detail_list: [],
        doc: '',
        template_code: '',
        template_name: '',
        voucher_type: '',
      }
      this.mainFields = []
      this.allDetailFields = []

      if (this.id || this.copyId) {
        this.fetchDetail()
      } else {
        this.addDetail()
      }
    },
    async fetchDocumentList() {
      try {
        const res = await http({
          url: api.financeDocument,
          data: { page_no: 1, page_size: 100, level: 0 },
        })
        this.documentList = res.result.list || []
      } catch (err) {
        console.error(err)
      }
    },
    async fetchAccountTableList() {
      try {
        const res = await http({
          url: api.getAccountTableList,
          data: { page_no: 1, page_size: 100 },
        })
        this.accountTableList = res.result.list || []
      } catch (err) {
        console.error(err)
      }
    },
    async fetchDetail() {
      try {
        const res = await http({
          url: api.getVoucherTemplateDetail,
          data: { id: this.id || this.copyId },
        })
        const data = res.result
        if (this.copyId) {
          delete data.id
          if (data.detail_list) {
            data.detail_list.forEach((item) => {
              delete item.id
              if (item.condition_list) {
                item.condition_list.forEach((cond) => {
                  delete cond.id
                })
              }
            })
          }
          if (data.condition_list) {
            data.condition_list.forEach((cond) => {
              delete cond.id
            })
          }
        }
        // Ensure detail_list has temp_id for table rowKey
        if (data.detail_list) {
          data.detail_list = data.detail_list.map((item) => {
            let amount = item.amount || ''
            let amount_sign = '1'
            if (amount.startsWith('-')) {
              amount_sign = '-1'
              amount = amount.substring(1)
            }
            return {
              ...item,
              temp_id: Date.now() + Math.random(),
              condition_list: (item.condition_list || []).map((cond) => ({
                ...cond,
                condition_value_type: cond.condition_value_type || 'FIXED',
              })),
              account_code: item.account_code,
              account_name: item.account_name,
              balance_direction: item.balance_direction,
              amount: amount,
              amount_sign: amount_sign,
            }
          })
        }
        const docPrefix = (data.doc || '') + '.'
        this.voucherTemplate = {
          ...this.voucherTemplate,
          ...data,
          accounting_date:
            data.accounting_date && !data.accounting_date.includes('.')
              ? docPrefix + data.accounting_date
              : data.accounting_date,
          biz_date:
            data.biz_date && !data.biz_date.includes('.')
              ? docPrefix + data.biz_date
              : data.biz_date,
          condition_list: (data.condition_list || []).map((item) => ({
            ...item,
            condition_value_type: item.condition_value_type || 'FIXED',
            condition_type:
              item.condition_type && !item.condition_type.includes('.')
                ? docPrefix + item.condition_type
                : item.condition_type,
          })),
        }

        if (this.voucherTemplate.doc) {
          await this.loadDocFields(this.voucherTemplate.doc)
        }
      } catch (err) {
        this.$message.error(this.$t('获取详情失败'))
      }
    },
    async handleDocChange(val) {
      // 切换单据时清空日期规则字段
      this.voucherTemplate.accounting_date = ''
      this.voucherTemplate.biz_date = ''
      await this.loadDocFields(val)
    },
    async loadDocFields(docCode) {
      try {
        // Fetch child docs and their fields for detail conditions
        const childRes = await http({
          url: api.financeDocument,
          data: { pageNo: 1, pageSize: 1000, parentCode: docCode },
        })
        this.childDocs = childRes.result.list || []
        const docCodes = [docCode, ...this.childDocs.map((d) => d.code)]

        const allFieldsRes = await http({
          url: api.getFinanceDocumentField,
          data: { financeDocumentCodeList: docCodes, page_no: 1, page_size: 999 },
        })
        const allList = allFieldsRes.result.list || []
        this.allDetailFields = allList
        // Filter for top-level mainFields
        this.mainFields = allList.filter((item) => item.finance_document_code === docCode)
      } catch (err) {
        console.error(err)
      }
    },
    handleAccountTableChange(val) {
      const item = this.accountTableList.find((i) => i.code === val)
      if (item) {
        this.voucherTemplate.account_table_name = item.name
      }
    },
    addCondition(list) {
      list.push({
        condition_express: '',
        condition_type: '',
        condition_value: '',
        condition_value_type: 'FIXED',
      })
    },
    removeCondition(list, index) {
      list.splice(index, 1)
    },
    addDetail() {
      this.voucherTemplate.detail_list.push({
        temp_id: Date.now() + Math.random(),
        account_code: '',
        account_name: '',
        account_value_type: 'FIXED',
        amount: '',
        amount_sign: '1',
        balance_direction: 'DEBIT',
        currency: '',
        summary: '',
        condition_list: [],
      })
    },
    removeDetail(index) {
      this.voucherTemplate.detail_list.splice(index, 1)
    },
    openAccountModal(record) {
      this.currentEditDetail = record
      this.$refs.selectAccountModalRef.open()
    },
    handleAccountSelected(selected) {
      if (selected && selected.length > 0 && this.currentEditDetail) {
        this.currentEditDetail.account_code = selected[0].code
        this.currentEditDetail.account_name = selected[0].full_name
      }
    },
    handleSave() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        this.saveLoading = true
        try {
          const docPrefix = (this.voucherTemplate.doc || '') + '.'
          const payload = {
            ...this.voucherTemplate,
            id: this.id,
            accounting_date:
              this.voucherTemplate.accounting_date &&
              this.voucherTemplate.accounting_date.startsWith(docPrefix)
                ? this.voucherTemplate.accounting_date.replace(docPrefix, '')
                : this.voucherTemplate.accounting_date,
            biz_date:
              this.voucherTemplate.biz_date && this.voucherTemplate.biz_date.startsWith(docPrefix)
                ? this.voucherTemplate.biz_date.replace(docPrefix, '')
                : this.voucherTemplate.biz_date,
            detail_list: this.voucherTemplate.detail_list.map((item) => ({
              ...item,
              amount: (item.amount_sign === '-1' ? '-' : '') + (item.amount || ''),
            })),
            condition_list: this.voucherTemplate.condition_list.map((item) => ({
              ...item,
              condition_type:
                item.condition_type && item.condition_type.startsWith(docPrefix)
                  ? item.condition_type.replace(docPrefix, '')
                  : item.condition_type,
            })),
          }
          await http({
            url: api.createOrUpdateVoucherTemplate,
            data: payload,
          })
          this.$message.success(this.$t('保存成功'))
          if (this.id) {
            // 编辑已有模板 刷新
            this.fetchDetail()
          } else {
            // 新建模板，返回上一页
            this.$router.back()
          }
        } catch (err) {
          this.$message.error(err || this.$t('保存失败'))
        } finally {
          this.saveLoading = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.voucher-template-detail {
  padding: 10px 0 24px 0;
  background: #f0f2f5;
  min-height: calc(100vh - 150px);

  .footer {
    position: fixed;
    bottom: 0;
    left: 185px;
    right: 0;
    height: 56px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 24px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
    z-index: 1000;
    transition: left 0.2s;
  }

  .text-danger {
    color: #ff4d4f;
  }

  .gap5 {
    gap: 5px;
  }

  :deep(.ant-card-head-title) {
    font-weight: 600;
  }
  :deep(.ant-form-item) {
    margin-bottom: 0px;
  }
}
</style>
